export default class Faq {

	static getHolderSelectors = () => ['.faq-element'];

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		const questions = Array.from(holderElement.querySelectorAll('[aria-controls]'));
		const answers = Array.from(holderElement.querySelectorAll('.answer'));

		/**
		 * @param {Event} event
		 */
		const toggle = (event) => {
			const current = event.currentTarget;
			const answer = document.getElementById(current.getAttribute('aria-controls'));
			if (!answer) {
				return;
			}

			const openAnswers = answers.filter(a => !a.hasAttribute('hidden'));

			window.requestAnimationFrame(() => {
				if (answer.hasAttribute('hidden')) {
					answer.removeAttribute('hidden');
					current.setAttribute('aria-expanded', 'true');

					const height = answer.scrollHeight;
					answer.style.maxHeight = '0px';
					answer.getBoundingClientRect(); // force reflow
					answer.style.maxHeight = `${height}px`;
					answer.addEventListener('transitionend', function openTransition(event) {
						if (event.propertyName !== 'max-height') {
							return;
						}
						answer.style.maxHeight = '';
						answer.removeEventListener('transitionend', openTransition);
					});
				}

				for (const openAnswer of openAnswers) {
					openAnswer.style.maxHeight = `${openAnswer.scrollHeight}px`;
					openAnswer.getBoundingClientRect(); // force reflow
					openAnswer.style.maxHeight = '0px';
					document.getElementById(openAnswer.getAttribute('aria-labelledby'))
						.querySelector('button')
						.setAttribute('aria-expanded', 'false');
					openAnswer.addEventListener('transitionend', function closeTransition(event) {
						if (event.propertyName !== 'max-height') {
							return;
						}
						openAnswer.style.maxHeight = '';
						openAnswer.setAttribute('hidden', '');
						openAnswer.removeEventListener('transitionend', closeTransition);
					});
				}
			});
		};

		for (const question of questions) {
			question.addEventListener('click', toggle);
		}
	}

}
